module.exports = __webpack_public_path__ + "static/media/gold.d052fd1b.png";